import React, { useState, useEffect } from 'react';
import { Modal, Form, Select, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMerchant } from '@contexts/operator/MerchantContext';
import { useIsStandard } from '@contexts/operator/PlanContext';
import { HideInStandard } from '@components/operator/shared/StandardGate';
import { pickingListService } from '@services/operator/pickingListService';

interface GeneratePickingListModalProps {
  open: boolean;
  onClose: () => void;
  selectedIds: string[];
  onSuccess: () => void;
}

interface MerchantOption {
  id: string;
  name: string;
}

const GeneratePickingListModal: React.FC<GeneratePickingListModalProps> = ({ open, onClose, selectedIds, onSuccess }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { merchants, merchantId } = useMerchant() as { merchants: MerchantOption[]; merchantId: string | null };
  const isStandard = useIsStandard();
  const [loading, setLoading] = useState(false);

  // 單一 merchant 模式下，隱藏選擇器並自動填入 merchant_id
  useEffect(() => {
    if (open && isStandard && merchantId) {
      form.setFieldsValue({ merchant_id: merchantId });
    }
  }, [open, isStandard, merchantId, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const payload = {
          fulfillment_ids: selectedIds,
          merchant_id: values.merchant_id,
          picking_method: 'batch',
      };

      const res = await pickingListService.create(payload);
      if (res.success) {
          message.success(t('common.create_success'));
          onSuccess();
          onClose();
      } else {
          message.error(res.message || t('common.create_failed'));
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t('operator.menu.picking_lists.generate')}
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <HideInStandard>
          <Form.Item
              name="merchant_id"
              label={t('operator.work_orders.list.columns.merchant')}
              rules={[{ required: true }]}
          >
              <Select
                  options={merchants.map((m) => ({ label: m.name, value: m.id }))}
                  placeholder={t('common.select_placeholder')}
              />
          </Form.Item>
        </HideInStandard>
      </Form>
    </Modal>
  );
};

export default GeneratePickingListModal;
